import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/layout/page-layout'
import WarehouseTable from '@/components/organisms/warehouse-table'
import { useAppSelector } from '@/redux/hooks'
import { PermissionsUtils } from '@/utils/permissions.utils'

export const Route = createFileRoute('/_authenticated/warehouse')({
  component: WarehouseRoute,
})

function WarehouseRoute() {
  const { t } = useTranslation()
  const activeWorkshopId = useAppSelector(state => state.settings.activeWorkshopId)

  if (!PermissionsUtils.hasPermission('spare-parts:read')) return null

  return (
    <div>
      <PageLayout title={t('warehousePage.title')}>
        <WarehouseTable workshopId={activeWorkshopId ?? ''} />
      </PageLayout>
      <Outlet />
    </div>
  )
}
